import ApiUtils from '../utils/ApiUtils';

let base = 'https://cards.tul.cz:8443/WS_LIANE/ldapservice/pwdpersms';


export default {


    /*
    * Async Promise
    * post password to server for change
    * @return status
    */
    changePassword(passwd, tokenSign, tokenPassword) {

            let data = {
                clientTicket: tokenSign,
                tokenPassword: tokenPassword,
                password: passwd
            };

            return new Promise((resolve, reject) => {
                let url = base + '/sendpwd';
                ApiUtils.post(url, data).then(function (results) {
                    resolve(results);
                }).catch(function (err) {
                    reject(err);
                });
            });
    },


    /*
    * Async Promise
    * post password to server for validation
    * @return status
    */
    validatePassword(passwd, tokenSign, tokenPassword) {

            let data = {
                clientTicket: tokenSign,
                tokenPassword: tokenPassword,
                password: passwd
            };

            return new Promise((resolve, reject) => {
                let url = base + '/validatepwd';
                ApiUtils.post(url, data).then(function (results) {
                    resolve(results);
                }).catch(function (err) {
                    reject(err);
                });
            });
    },

    /*
    * Async Promise
    * post birthCode to server
    * @return status
    */
    sendBirth(birthCode, tokenSign, tokenVerify) {

            let data = {
                clientTicket: tokenSign,
                tokenVerify: tokenVerify,
                verify: birthCode
            };

            return new Promise((resolve, reject) => {
                let url = base + '/sendverify';
                ApiUtils.post(url, data).then(function (results) {
                    resolve(results);
                }).catch(function (err) {
                    reject(err);
                });
            });
        },

    /*
     * Async Promise
     * post birthCode to server
     * @return status
     */
    sendSmsCode(SmsCode, tokenSign, tokenVerify) {

        let data = {
            clientTicket: tokenSign,
            tokenSms: tokenVerify,
            smscode: SmsCode
        };

        return new Promise((resolve, reject) => {
            let url = base + '/sendsmscode';
            ApiUtils.post(url, data).then(function (results) {
                resolve(results);
            }).catch(function (err) {
                reject(err);
            });
        });
    },


    /*
    * Async Promise
    * post username to server
    * @return status
    */
    sendUserName(userName, tokenSign) {

            let data = {
                clientTicket: tokenSign,
                username: userName
            };

            return new Promise((resolve, reject) => {
                let url = base + '/sendusername';
                ApiUtils.post(url, data).then(function (results) {
                    resolve(results);
                }).catch(function (err) {
                    reject(err);
                });
            });
        },

     /*
    * Async Promise
    * send client ticket - testing method
    */
    sendClientTicket(ticket) {

            let data = {
                clientTicket: ticket
            };

            return new Promise((resolve, reject) => {
                let url = base + '/sendclientticket';
                ApiUtils.post(url, data).then(function (results) {
                    resolve(results);
                }).catch(function (err) {
                    reject(err);
                });
            });
        }
};
